// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/AkkhorLayout";
import { useSelector } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
const _ = require('lodash');

function Dashboard() {
  const { user } = useSelector((state) => state.auth);
  const MyRole = JSON.parse(user && user.data.roles ? user.data.roles : '{}')
  const location = useLocation();
  let localsegment = location.pathname;
  let listMenus = [
    {
      title: 'Khách hàng của tôi', icon: 'fas fa-users', link: '/khach-hang-cua-toi', active: ['/khach-hang-cua-toi'].includes(localsegment),
    },
    {
      title: 'Khách hàng đã chốt', icon: '	fas fa-user-tie', link: '/khach-hang-da-chot', active: ['/khach-hang-da-chot'].includes(localsegment),
    },
    {
      title: 'Quản lý khách hàng', icon: 'fab fa-pinterest', link: '/khach-hang', active: ['/khach-hang'].includes(localsegment),
    },
    {
      title: 'Sản phẩm', icon: 'fas fa-building', link: '/du-an', active: ['/du-an'].includes(localsegment),
    },
  ];
  const checkRole = (idparent, menu) => {
    let isrole = false;
    let id = menu.id;
    if (!id) id = _.trimStart(menu.link, ' /');
    if (id) {
      if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(id) && MyRole[idparent].children[id].checked === true) isrole = true
      else if (MyRole.hasOwnProperty(id) && MyRole[id].checked === true) isrole = true
    } else {
      if (menu.hasOwnProperty('children') && menu.children && menu.children.length > 0) {
        menu.children.map((sub) => {
          let idsub = _.trimStart(sub.link, ' /');
          if (idparent && MyRole.hasOwnProperty(idparent) && MyRole[idparent].children.hasOwnProperty(idsub) && MyRole[idparent].children[idsub].checked === true) isrole = true
          else if (idsub && MyRole.hasOwnProperty(idsub) && MyRole[idsub].checked === true) isrole = true
          return sub;
        })
      }
    }
    return isrole
  }
  return (
    <AkkhorLayout idrole="dashboard">
      <h2 className="mt-2 w-100 text-center">Trang chủ</h2>
      <div className="row menu-dashboard">
        {listMenus.map((item, i) => {
          if (checkRole(null, item) || item.role) {
            return <div className="col-4 d-flex justify-content-center align-items-center item-menu" key={i}>
              <a href={item.link} className="wrapper shadow-sm d-flex justify-content-center align-items-center">
                <div className="insite">
                  <span className={item.icon}></span>
                  <p>{item.title}</p>
                </div>
              </a>
            </div>
          }
        }
        )}

      </div>
    </AkkhorLayout>
  );
}

export default Dashboard;
